import React, { useState, useEffect } from 'react';

function DateSnippet() {
    const [time, setTime] = useState();

    useEffect(() => {
        displayDate();
    });

    function lPadDatetimes(value) {
        let paddedText = (value < 10) ? "0" + value : value;
        return paddedText;
    }

    const displayDate = () => {
        let date = new Date();
        let fullYear = date.getFullYear();
        let month = date.getMonth() + 1; // 0 - 12
        let day = date.getDate(); // 0 - 31

        let hours = date.getHours(); // 0 - 23
        let minutes = date.getMinutes(); // 0 - 59
        let seconds = date.getSeconds(); // 0 - 59

        day = lPadDatetimes(day);
        month = lPadDatetimes(month);
        hours = lPadDatetimes(hours);
        minutes = lPadDatetimes(minutes);
        seconds = lPadDatetimes(seconds);

        let time = day + '/' + month + '/' + fullYear + ' | ' + hours + ":" + minutes + ":" + seconds + " ";
        setTimeout(displayDate, 1000);
        setTime(time);
    };

    return (
        <div>
            <span>{time}</span>
        </div>
    );
}

export default DateSnippet;



